module.exports = __webpack_public_path__ + "static/media/second_slide.6e1c47bf.jpg";